import { render, staticRenderFns } from "./LSDashboardPage.vue?vue&type=template&id=50c3d308&scoped=true"
import script from "./LSDashboardPage.vue?vue&type=script&lang=js"
export * from "./LSDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./LSDashboardPage.vue?vue&type=style&index=0&id=50c3d308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c3d308",
  null
  
)

export default component.exports